import { CircularProgress } from '@material-ui/core';

/**
 * @deprecated use CircularProgress from atoms/CircularProgress instead
 */
const Loader = () => (
  <div className="material-loader-wrapper">
    <CircularProgress className="material-spinner" />
  </div>
);

export default Loader;
